import { EnvelopeSimple, Phone } from '@phosphor-icons/react'
import clsx from 'clsx'
import Link from 'next/link'
import { Website } from '@/src/@types/blinkadmin'
import { PageInfo } from '@/src/@types/models'
import { ContactLocalBlock } from '@/src/@types/statamic'
import { get } from '@/src/BlinkAdminApiClient'
import WhatsappIcon from '@/src/components/core/icons/WhatsappIcon'
import { normalizeInternational } from '@/src/lib/phone'

export async function getStaticProps({ single_location }: ContactLocalBlock) {
  const locations = await get<Website.Location[]>(
    `/website/v2/locations?filter[id]=${single_location.value}`
  )

  const location = locations[0] || null

  return {
    location: location as Website.Location | null,
  }
}

export default function Component({
  location,
  pageInfo,
}: Awaited<ReturnType<typeof getStaticProps>> & {
  pageInfo: PageInfo
}) {
  if (!location) return null

  const phone = location?.phone || '031 539 10 65'
  return (
    <div
      className={clsx(
        'relative overflow-hidden bg-linear-to-b from-gray-50 to-gray-100 px-5 py-16 md:py-24',
        {
          'mt-20 md:mt-32': pageInfo.newSpacing,
        }
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="905"
        height="902"
        fill="none"
        className="absolute -top-23.75 left-12 hidden md:block"
      >
        <path
          stroke="#eff2fb"
          stroke-width="20"
          d="M452.212 10C694.445 10 891.578 206.148 894.4 448.087l.025 2.849c-.029 243.15-197.688 440.829-442.213 440.829C207.669 891.765 10 694.056 10 450.882 10 207.707 207.669 10 452.212 10Z"
        />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="524"
        height="524"
        fill="none"
        className="absolute top-20.75 left-8.75 md:top-23.75 md:left-280"
      >
        <path
          stroke="#eff2fb"
          stroke-width="20"
          d="M211.757 14.814C347.304-12.04 480.398 76.19 508.577 213.133c6.399 33.33 6.379 66.574-.002 98.478l-.013.073c-19.178 99.725-97.17 177.715-196.895 196.893l-.037.008C175.204 535.36 42.694 447.832 15.12 311.917l-.32-1.601c-6.407-33.346-6.391-66.606-.007-98.526l.008-.036.007-.036C33.986 111.992 111.976 34.002 211.7 14.824l.028-.006z"
        />
      </svg>
      <div className="relative z-10 mx-auto max-w-240">
        <h2 className="text-4xl font-black md:text-center md:text-20xl">
          Du hast Fragen? Kontaktiere uns!
        </h2>
        <p className="mt-4 md:mt-6 md:text-center">
          Du erreichst uns von Montag bis Freitag: 08.00 – 12:00 und 13:00 –
          17.00 Uhr und am Samstag 8:00 – 12:00 Uhr
        </p>
        <div className="mt-6 divide-y divide-gray-200 text-gray-800 md:mt-12 md:flex md:divide-x md:divide-y-0">
          <Link
            href={`tel:${normalizeInternational(phone)}`}
            className="flex items-center space-x-4 py-4 md:flex-1 md:justify-center md:px-6"
          >
            <Phone size={32} weight="bold" className="shrink-0" />
            <div>
              <p className="text-sm">Telefon</p>
              <p className="mt-1 font-bold md:text-lg">{phone}</p>
            </div>
          </Link>
          <Link
            href={`https://wa.me/41315391065?text=Liebes%20BLINK%20Team%2C%20`}
            className="flex items-center space-x-4 py-4 md:flex-1 md:justify-center md:px-6"
          >
            <WhatsappIcon size={32} className="shrink-0" />
            <div>
              <p className="text-sm">WhatsApp</p>
              <p className="mt-1 font-bold md:text-lg">031 539 10 65</p>
            </div>
          </Link>
          <Link
            href={`mailto:${location.email}`}
            className="flex items-center space-x-4 py-4 md:flex-1 md:justify-center md:px-6"
          >
            <EnvelopeSimple size={32} weight="bold" className="shrink-0" />
            <div>
              <p className="text-sm">E-Mail</p>
              <p className="mt-1 font-bold md:text-lg">{location.email}</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
